<template>
  <v-data-table
    :headers="itemProps.headers"
    :items="items"
    :search="search"
    :options.sync="options"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50, -1]
    }"
    dense
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>{{ itemProps.toolbarTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          class="mr-8"
        />
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="accent"
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              New {{ itemProps.title }}
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="text-h5 accent lighten-2">
              <span>{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    class="text-center"
                  >
                    <region-form
                      v-if="itemProps.title === 'Region'"
                      :editedItem="itemProps.editedItem"
                      :regions="regions"
                    />
                    <f5nic-form
                      v-if="itemProps.title === 'F5 NIC'"
                      :editedItem="itemProps.editedItem"
                      :regions="regions"
                    />
                    <sqlserver-form
                      v-if="itemProps.title === 'SQL Server'"
                      :editedItem="itemProps.editedItem"
                      :regions="regions"
                    />
                    <sqllb-form
                      v-if="itemProps.title === 'SQL Load Balancer'"
                      :editedItem="itemProps.editedItem"
                      :regions="regions"
                      :sqlServers="sqlServers"
                    />
                    <permissionlevels-form
                      v-if="itemProps.title === 'Permission'"
                      :editedItem="itemProps.editedItem"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-spacer />
              <v-btn
                text
                @click="close"
              >
                CANCEL
              </v-btn>
              <v-btn
                color="accent"
                @click="save"
              >
                CONFIRM
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5 accent lighten-2">Delete Permission</v-card-title>
            <v-card-text>
              <v-container>
                <v-alert
                  type="warning"
                  outlined
                  prominent
                  text
                >
                  This will delete the following permission from the database. Are you sure you want to continue?
                </v-alert>
                <p class="text-h4 text-center">{{ itemProps.editedItem.name }} : {{ itemProps.editedItem.description }}</p>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="closeDelete">Cancel</v-btn>
              <v-btn color="accent"  @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.region_id="{ item }">
      {{ getRegion(item.region_id) }}
    </template>
    <template v-slot:item.dr_region_id="{ item }">
      {{ getRegion(item.dr_region_id) }}
    </template>
    <template v-slot:item.primary_server_id="{ item }">
      {{ getServerName(item.primary_server_id) }}
    </template>
    <template v-slot:item.secondary_server_id="{ item }">
      {{ getServerName(item.secondary_server_id) }}
    </template>
    <template v-slot:item.rds_server="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.primary_server="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.customer_ag="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.disable_alerts="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <!-- Leaving delete option commented out for now, to be enabled in future -->
      <!-- <v-icon
        v-if="itemProps.title === 'Permission'"
        small
        @click="deleteItemDialog(item)"
      >
        mdi-delete
      </v-icon> -->
    </template>
  </v-data-table>
</template>
<script>
  import axios from 'axios'
  import { authHeader } from '@/util/helpers'
  import getEnv from '@/util/env'
  const host = getEnv('VUE_APP_API_HOST')
  export default {
    name: 'ItemsTab',
    props: {
      itemProps: Object
    },
    data () {
      return {
        dialog: false,
        dialogDelete: false,        
        editedIndex: -1,
        search: '',
        options: {
          itemsPerPage: 30,
        },
      }
    },
    created () {
      this.$store.dispatch(this.itemProps.itemsDispatch)
    },
    computed: {
      items () {
        return this.$store.getters[this.itemProps.itemsGetter]
      },
      regions  () {
        return this.$store.getters['settings/regions']
      },
      sqlServers  () {
        return this.$store.getters['settings/sql_servers']
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New ' + this.itemProps.title : 'Edit ' + this.itemProps.title
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    methods: {
      getRegion (regionId) {
        if (!regionId) return ''
        return this.regions.filter(element => element.region_id === regionId)[0].region_short
      },
      getServerName (serverId) {
        if (!serverId) return ''
        return this.sqlServers.filter(element => element.sql_server_id === serverId)[0].sql_server_name
      },
      displayIcon: function (item) {
        if (item === 'y') {
          return 'mdi-check'
        } else {
          return 'mdi-close'
        }
      },
      iconColour: function (item) {
        if (item === 'y') {
          return 'success'
        } else {
          return 'error'
        }
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.itemProps.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItemDialog (item) {
        this.editedIndex = this.items.indexOf(item)
        this.itemProps.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.deleteItem(this.itemProps.editedItem)
        this.closeDelete()
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.itemProps.editedItem = Object.assign({}, this.itemProps.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.itemProps.editedItem = Object.assign({}, this.itemProps.defaultItem)
          this.editedIndex = -1
        })
      },
      save () {
        if (Object.hasOwn(this.itemProps.editedItem, 'availability_group')) {
          this.itemProps.editedItem.availability_group = this.itemProps.editedItem.availability_group === '' ? null : this.itemProps.editedItem.availability_group
        }

        if (this.editedIndex > -1) {
          this.updateItem(this.itemProps.editedItem)
        } else {
          this.createItem(this.itemProps.editedItem)
        }
        this.close()
      },
      createItem: function (itemData) {
        axios
          .post(
            `${host}${this.itemProps.apiUrl}new`,
            itemData,
            {
              headers: authHeader(),
            },
          ) // eslint-disable-next-line
          .then(response => {
            this.$snackbar.showMessage({ content: this.itemProps.title + ' created', color: 'success', timeout: 5000 })
            setTimeout(() => this.$store.dispatch(this.itemProps.itemsDispatch), 1000)
          })
          .catch(err => {
            console.log(err)
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
      updateItem: function (itemData) {
        axios
          .put(
            `${host}${this.itemProps.apiUrl}` + itemData[this.itemProps.uniqueId],
            itemData,
            {
              headers: authHeader(),
            },
          ) // eslint-disable-next-line
          .then(response => {
            this.$snackbar.showMessage({ content: this.itemProps.title + ' updated', color: 'success', timeout: 5000 })
            setTimeout(() => this.$store.dispatch(this.itemProps.itemsDispatch), 1000)
          })
          .catch(err => {
            console.log(err)
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
      deleteItem: function (itemData) {
        axios
          .delete(
            `${host}${this.itemProps.apiUrl}` + itemData[this.itemProps.uniqueId],
            {
              headers: authHeader(),
              data: itemData,
            },
          ) // eslint-disable-next-line
          .then(response => {
            this.$snackbar.showMessage({ content: this.itemProps.title + ' deleted', color: 'success', timeout: 5000 })
            setTimeout(() => this.$store.dispatch(this.itemProps.itemsDispatch), 1000)
          })
          .catch(err => {
            console.log(err)
            this.$errordialog.showMessage({ content: err.response.data.message, color: 'error', title: 'Oops! Something went wrong.' })
          })
      },
    }
  }
</script>